const subtitles = [
  "Explore your city and unlock every street you walk, run or drive.",
  "Turn your city into a map you uncover.",
  "See how much of your city you have really covered.",
];

const introduction = [
  {
    type: "text/main_title_subtitle",

    verticalAlign: "center",
    horizontalAlign: "center",

    titles: ["City Unlock"],
    subtitles,
    textStyle: {
      textAlign: "center",
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },
];

const description = [
  {
    type: "text/title_subtitle",

    titles: ["Your City, Street by Street"],
    subtitles: [
      "Start a walk, run or drive and City Unlock lights up every street you cover, then shows what share of your city you have unlocked on foot and by car. Climb the city leaderboards, follow collections like coffee shops or parks to visit them one by one, and pin photos of the places worth coming back to.",
    ],
    textStyle: {
      textAlign: "center",
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },
];

const screenshot = [
  {
    type: "screenshot/single_enlarged",

    screenshots: [
      {
        src: "city-unlock/assets/screenshots/explore_map.jpg",
        alt: "Screenshot of the City Unlock map with a city's streets and progress",
      },
    ],
    containerStyle: {
      paddingTop: "4em",
    },
  },
];

const mobile_screenshot = [
  {
    ...screenshot[0],
    containerStyle: {},
  },
];

export const city_unlock_config = {
  name: "City Unlock",
  subtitles,
  backgroundColor: "#109B73",

  //Vanta
  highlightColor: "#2EE6A6",
  midtoneColor: "#1DB37E",
  lowlightColor: "#0B6E52",
  baseColor: "#109B73",

  path: "/city-unlock",

  title: "City Unlock: Explore Every Street of Your City",
  description:
    "City Unlock turns your city into a map you uncover. Walk, run or drive to unlock streets, see what share of your city you have covered, climb the city leaderboards and pin photos of interesting places.",
  keywords:
    "City Unlock, Explore Your City, Unlock Streets, Walk Every Street, Run Every Street, City Exploration Map, Street Coverage Tracker, City Leaderboard",

  sections: [
    {
      type: "layout/split_horizontal",
      leftFlex: 5,
      rightFlex: 5,
      contentLeft: [...introduction, ...description],
      contentRight: [...screenshot],
    },
  ],
  mobileSections: [...introduction, ...mobile_screenshot, ...description],
};
